module.exports = __webpack_public_path__ + "media/components/assets/img/logo/norwegian-c001fcbedfb9e89887ca3759e309f312.png";